import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Wordmark } from "@/components/Logo";
import { toast } from "sonner";

export default function Register() {
    const { register } = useAuth();
    const [form, setForm] = useState({ name: "", email: "", password: "", university: "", major: "" });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await register(form);
        setLoading(false);
        if (res.ok) { toast.success("Welcome to StudySphere"); navigate("/app"); }
        else toast.error("Registration failed", { description: res.error });
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6">
            <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="register-form">
                <div className="text-center"><Wordmark /></div>
                <div>
                    <div className="mono-label mb-2">Create account</div>
                    <h2 className="font-display text-3xl font-medium tracking-tight">Start your semester right.</h2>
                    <p className="text-sm text-muted-foreground mt-2">Join thousands of students focusing better.</p>
                </div>

                <div className="space-y-4">
                    <div>
                        <Label className="text-xs mono-label">Name</Label>
                        <Input data-testid="reg-name" value={form.name} onChange={set("name")} required className="mt-1.5" />
                    </div>
                    <div>
                        <Label className="text-xs mono-label">Email</Label>
                        <Input data-testid="reg-email" type="email" value={form.email} onChange={set("email")} required className="mt-1.5" />
                    </div>
                    <div>
                        <Label className="text-xs mono-label">Password</Label>
                        <Input data-testid="reg-password" type="password" value={form.password} onChange={set("password")} minLength={6} required className="mt-1.5" />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <Label className="text-xs mono-label">University</Label>
                            <Input data-testid="reg-university" value={form.university} onChange={set("university")} className="mt-1.5" placeholder="Optional" />
                        </div>
                        <div>
                            <Label className="text-xs mono-label">Major</Label>
                            <Input data-testid="reg-major" value={form.major} onChange={set("major")} className="mt-1.5" placeholder="Optional" />
                        </div>
                    </div>
                </div>

                <Button type="submit" disabled={loading} className="w-full h-11" data-testid="register-submit">
                    {loading ? "Creating…" : "Create account"}
                </Button>

                <p className="text-sm text-center text-muted-foreground">
                    Already have an account? <Link to="/login" className="text-primary font-medium hover:underline">Sign in</Link>
                </p>
            </form>
        </div>
    );
}
